import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppErrorBoundary, installVelloTheme, installWebCrashCapture } from '@vello/web-theme';
import '@vello/web-theme/fonts.css';
import '@vello/web-theme/theme.css';
import { App } from './App';
import { createWebAdminRuntime } from './runtime';

// The Vello design system comes entirely from `@vello/web-theme` (the single source across every web app):
// the self-hosted fonts, the component/interaction CSS, and the token + effect layer injected on `:root`. The
// Admin adds no theme of its own — it composes this. `installVelloTheme()` defaults to the light surface.
// D798: light by default, with the apps' navy dark — the operator's choice (sidebar foot) or the system's.
installVelloTheme(undefined, { dark: true });
// D442 (X-08): uncaught errors and unhandled rejections are recorded (redacted); a crashed screen shows the fallback.
installWebCrashCapture('admin');

const runtime = createWebAdminRuntime();

const container = document.getElementById('root');
if (container === null) throw new Error('Vello Admin: missing #root mount node');
createRoot(container).render(
  <StrictMode>
    <AppErrorBoundary app="admin">
      <App runtime={runtime} />
    </AppErrorBoundary>
  </StrictMode>,
);
